import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=bdcab19c&"
import script from "./ContactInfo.vue?vue&type=script&lang=js&"
export * from "./ContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdcab19c')) {
      api.createRecord('bdcab19c', component.options)
    } else {
      api.reload('bdcab19c', component.options)
    }
    module.hot.accept("./ContactInfo.vue?vue&type=template&id=bdcab19c&", function () {
      api.rerender('bdcab19c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/contact/ContactInfo.vue"
export default component.exports